import HcpVideos from "@/page-components-hcp/videos";

export default function HcpVideosPage() {

  return <HcpVideos />;
}

// Forward layout props to `_app` so it can wrap with the proper layout
HcpVideosPage.getLayoutProps = (pageProps, router) => (
  typeof HcpVideos.getLayoutProps === 'function'
    ? HcpVideos.getLayoutProps(pageProps, router)
    : {}
);